import React, { useCallback, useEffect, useRef, useState } from 'react';

import API from "@utilities/smart_api";

import CharactersInput from '@dndComponents/character/CharactersInput';
import { useAuth } from 'react-oidc-context';

const api = API.getInstance();

export default function CharacterIndex() {
  const auth = useAuth(); 
  const [reloading, setReloading] = useState(false);
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const reload = useCallback(() => {
    setReloading(true);
  }, []);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  useEffect(() => {
    api.subscription_holder.subscribe("Authenticated", mounted, reload);
    api.subscription_holder.subscribe("Reload", mounted, reload);
    api.subscription_holder.subscribe("Logout", mounted, reload);
  }, [reload]);

  if (auth.isLoading) {
    return (<div className="centered">Authenticating</div>);
  } else if (api.user === null) {
    return (
      <span className="header">You have to log in to use this page.</span>
    );
  } else {
    return (
      <CharactersInput />
    ); 
  } 
}

